import {
  TIPO_DOCUMENTO_COMERCIAL,
  TipoDocumentoComercialType,
} from "api/Types/TipoDocumentoComercial"

export const OCRColoredNumber = ({
  type,
  label,
}: {
  type?: TipoDocumentoComercialType
  label?: string
}) => {
  const colorClass =
    type === TIPO_DOCUMENTO_COMERCIAL.COMPRA
      ? "tw-text-danger"
      : type === TIPO_DOCUMENTO_COMERCIAL.VENTA
      ? "tw-text-secondary"
      : "tw-text-text"
  return (
    <span className={colorClass}>{`${
      type === TIPO_DOCUMENTO_COMERCIAL.COMPRA ? `-${label}` : label
    }`}</span>
  )
}
